module.exports = __webpack_public_path__ + "static/media/contact-bg.c3db38cd.png";